import _ from 'lodash';
import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip';

import {
  LanguageSelect,
  TalentProfileSelect
} from '../../shared';

import {
  getIcon,
  localizeDimension,
  localizeProfile,
  localizeDimensionCategory,
  getCategoryNameFromId,
  getDimensionFamilyFromId,
} from '../../../util';

import { dimensions } from '../../../data/dimensions';

class TalentDimensionsAdminSection extends Component{

  state = {
    viewingLanguage: 'en',
    viewingProfile: 'default',
  }

  getLabelLocalizationForDimension(dimension){
    const { viewingLanguage, viewingProfile } = this.state;

    return localizeDimension({
      dimensionId: dimension.id,
      profileId: viewingProfile,
      appLocalizations: this.props.appConfig.localizations,
      language: viewingLanguage
    }) || dimension.label;
  }

  getLocalizedCategoryLabelForDimension(dimension){
    const { viewingLanguage } = this.state;

    //todo implement languages
    return localizeDimensionCategory({
      categoryId: dimension.categoryId,
      appLocalizations: this.props.appConfig.localizations,
      language: viewingLanguage
    }) || getCategoryNameFromId(dimension.categoryId);
  }

  render(){

    if(!this.props.appConfig){
      return null;
    }

    return (
      <div className="manage-talent-dimensions">

        <LanguageSelect
          currentLanguage={this.state.viewingLanguage}
          changeLanguage={newLanguage => { this.setState({ viewingLanguage: newLanguage }); }}
        />

        <TalentProfileSelect
          language={this.state.viewingLanguage}
          currentProfile={this.state.viewingProfile}
          changeProfile={newProfile => { this.setState({ viewingProfile: newProfile }); }}
        />

        {/*const dimensionForProfile = this.state.viewingProfile.dimensions;*/}

        <div className="talent-profiles-list">
          {_.map(dimensions, dimension => {

            const {
              id,
              name,
              dimensionFamily,
              legacyId,
            } = dimension;

            const dimensionFamilyData = getDimensionFamilyFromId(dimensionFamily);

            return (
              <div key={`talent-profile-${id}`} className={`talent-profile`}>
                <div className="profile-info">
                  <div className="id">{id} / {name}</div>
                  <div className="label">{name}</div>
                  <div className="category">&nbsp;{dimensionFamilyData.label}&nbsp;@{legacyId}&nbsp;</div>
                </div>
            </div>
            )
          })}
          </div>
        </div>
    )
  }
}

export default TalentDimensionsAdminSection;



// WEBPACK FOOTER //
// ./src/components/admin/sections/talentDimensionsAdminSection.js